import CONFIG from '../config/production.json';
const apiId = CONFIG.API.ID;
const environment = CONFIG.API.ENV;
export const region = CONFIG.REGION;
export const bucket_name = CONFIG.S3.BUCKET_NAME;

const base_url = `https://${apiId}.execute-api.${region}.amazonaws.com/${environment}`;

export default base_url;
